<mat-form-field
  appearance="outline"
  [ngClass]="{ failed: !!UOMValidation || !validSnapshot || !!warning }"
  class="miq-form-input"
>
  <ng-container *ngIf="!isMaskedValue; else maskedInput">
    <input
      #inputContainer
      matInput
      miqOnlyNumbers
      type="text"
      step="step"
      [restrictedKeyCodes]="restrictedKeyCodes"
      [allowedKeyCodes]="allowedKeyCodes"
      [required]="required"
      [autocomplete]="autocompleteValue"
      [placeholder]="placeholder"
      [maxlength]="maxlength"
      [formControl]="fc"
      [value]="valueToDisplay"
      (blur)="emitAndFormat()"
      (paste)="onPaste($event)"
      [avoidCopyPaste]
      [avoidActions]="avoidCopyandPasteActions"
    />
  </ng-container>

  <ng-template #maskedInput>
    <input
      matInput
      autocomplete="new-password"
      type="password"
      disabled
      [value]="currentValue"
      [avoidCopyPaste]
      [avoidAllActions]="true"
    />
  </ng-template>
</mat-form-field>
